export enum ProcessesEnums {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
  STORAGE = "STORAGE",
  PRODUCTIVITY = "PRODUCTIVITY"
}

export const ALERTS_PER_TAB = 3;